
function DemoAccountService(demoAccount, i18n, $rootScope, $q) {
  this.demoAccount = demoAccount;
  this.i18n = i18n;
  this.$rootScope = $rootScope;
  this.$q = $q;
}

DemoAccountService.prototype.isDemoAccount = function() {
  return this.demoAccount;
};

DemoAccountService.prototype.displayDemoAccountAlert = function(messageCode) {
  this.$rootScope.alertController.addTemporaryAlert(
    this.i18n(messageCode || 'fe.error.demoaccount.generic'),
    'error'
  );
};

/**
 * Use this method in a route resolve to reject the route change when a demo account is present.
 * Example (the DemoAccountServiceProvider can NOT be used for this since the isDemoAccount property is set too late)
 * resolve: {
 *   noDemo: function(DemoAccountService) {
 *      return DemoAccountService.routeResolve();
 *   }
 * }
 * @returns {Promise} Resolved when the account is not a demo account, rejected otherwise.
 */
DemoAccountService.prototype.routeResolve = function() {
  var deferred = this.$q.defer();
  if (this.isDemoAccount()) {
    deferred.reject('demo-account');
  } else {
    deferred.resolve(true);
  }
  return deferred.promise;
};

/**
 * We use a provider for the demo account service so we can know if we're running a demo account even in the config
 * stages of the app.
 */
export function demoAccountServiceProvider() {
  this.isDemoAccount = false;

  this.setIsDemoAccount = function(isDemoAccount) {
    this.isDemoAccount = isDemoAccount;
  };

  this.$get = [
    'i18nFilter',
    '$rootScope',
    '$q',
    function(i18nFilter, $rootScope, $q) {
      return new DemoAccountService(
        this.isDemoAccount,
        i18nFilter,
        $rootScope,
        $q
      );
    }
  ];
}
